import "../../../../stylesheets/products";
import AutoNumeric from "autonumeric";
import { managePaymentOptions } from "../../utils";
import { setupAutoNumeric } from "../../../utils";

$(document).ready(function () {
  if (
    window.performance &&
    window.performance.navigation.type ===
    window.performance.navigation.TYPE_BACK_FORWARD
  ) {
    $("#product-quantity-desktop").attr("autocomplete", "off");
    $("#product-quantity-mobile").attr("autocomplete", "off");
  }

  // Cause Products
  $("#product-quantity-desktop").on("change", function (target) {
    const quantity = parseInt($("#product-quantity-desktop").val()) || 0;
    calculateAndUpdateAmount(quantity, 'desktop');
    $("#product-quantity-mobile").val($("#product-quantity-desktop").val());
  });

  $("#product-quantity-mobile").on("change", function (target) {
    const quantity = parseInt($("#product-quantity-mobile").val()) || 0;
    calculateAndUpdateAmount(quantity, 'mobile');
    $("#product-quantity-desktop").val($("#product-quantity-mobile").val());
  });

  // Función para calcular el monto (rifa con precios diferenciados o precio normal)
  function calculateAndUpdateAmount(quantity, device) {
    const currency = $("#currency-type")[0]?.value || "clp";
    const raffleContainer = document.querySelector(".app-container.raffle");
    const campaignId = raffleContainer?.getAttribute("data-campaign-id");

    if (campaignId && quantity > 0 && currency === "clp") {
      $.ajax({
        url: "/calculate_raffle_price",
        method: "GET",
        data: {
          campaign_id: campaignId,
          quantity: quantity,
          currency: currency
        },
        success: function (response) {
          let total_amount = response.price;
          update_product_amount(total_amount);
        },
        error: function (xhr, status, error) {
          console.error("AJAX error:", { xhr, status, error });
          calculateNormalAmount(quantity, currency);
        }
      });
    } else {
      calculateNormalAmount(quantity, currency);
    }
  }

  function calculateNormalAmount(quantity, currency) {
    let total_amount;
    const priceInput = currency === "clp"
      ? $("#product-quantity-desktop")[0]?.getAttribute("data-price")
      : $("#product-quantity-desktop")[0]?.getAttribute("data-price-usd");

    if (currency === "clp") {
      total_amount = (parseFloat(priceInput) || 0) * quantity;
    } else if (currency === "usd") {
      total_amount = ((parseFloat(priceInput) || 0) * quantity).toString().replace(".", ",");
    }
    update_product_amount(total_amount);
  }
});
export const update_product_currency = (currency) => {
  const quantity = parseInt($("#product-quantity-desktop").val()) || 0;
  const raffleAmounts = document.getElementById("raffle-amounts");

  if (currency == "clp") {
    $("#unitary-price")[0].innerText = new Intl.NumberFormat("es-CL", {
      currency: "CLP",
      style: "currency",
      maximumFractionDigits: 0,
    }).format($("#unitary-price")[0].getAttribute("clp-price"));
    $(".usd-ticket-price").hide();
    $(".clp-ticket-price").show();
  } else if (currency == "usd") {
    $("#unitary-price")[0].innerText = new Intl.NumberFormat("es-CL", {
      currency: "USD",
      style: "currency",
      maximumFractionDigits: 0,
    }).format($("#unitary-price")[0].getAttribute("usd-price"));
    $(".usd-ticket-price").show();
    $(".clp-ticket-price").hide();
  }

  const raffleContainer = document.querySelector(".app-container.raffle");
  const campaignId = raffleContainer?.getAttribute("data-campaign-id");

  if (campaignId) {

    $.ajax({
      url: "/calculate_raffle_price",
      method: "GET",
      data: {
        campaign_id: campaignId,
        quantity: quantity,
        currency: currency
      },
      success: function (response) {
        let total_amount = response.price;
        if (currency === "usd") {
          total_amount = total_amount.toString().replace(".", ",");
        }
        update_product_amount(total_amount);
      },
      error: function () {
        let total_amount;
        if (currency == "clp") {
          total_amount =
            $("#product-quantity-desktop")[0].getAttribute("data-price") *
            quantity;
        } else if (currency == "usd") {
          total_amount = ($("#product-quantity-desktop")[0].getAttribute("data-price-usd") * quantity).toString().replace(".", ",");
        }
        update_product_amount(total_amount);
      }
    });
  } else {
    let total_amount;
    if (currency == "clp") {
      total_amount =
        $("#product-quantity-desktop")[0].getAttribute("data-price") *
        quantity;
    } else if (currency == "usd") {
      total_amount = ($("#product-quantity-desktop")[0].getAttribute("data-price-usd") * quantity).toString().replace(".", ",");
    }
    update_product_amount(total_amount);
  }
};
export const update_product_amount = (total_amount) => {
  const desktopElement = $("#total_amount_product_desktop");
  const mobileElement = $("#total_amount_product_mobile");
  const amountInput = $("#donator_donation_transactions_attributes_0_amount")[0];

  if (desktopElement.length) {
    desktopElement.text(total_amount);
    setupAutoNumeric($("#currency-type")[0].value, null, "#total_amount_product_desktop", "$");
  }

  if (mobileElement.length) {
    mobileElement.text(total_amount);
    setupAutoNumeric($("#currency-type")[0].value, null, "#total_amount_product_mobile", "$");
  }

  if (amountInput) {
    amountInput.setAttribute("value", total_amount);
  }
};
export const manageProductsCurrencies = (
  new_product_price,
  new_product_price_usd
) => {
  let local_currency = $("#local-currency")?.[0]?.innerHTML;
  if (!local_currency) {
    return;
  }
  if (
    $("#currency-type")[0].value == "usd" &&
    parseInt(new_product_price_usd) > 0
  ) {
    if (!(parseInt(new_product_price) > 0)) {
      $(".currency_container").hide();
    } else {
      $(".currency_container").show();
    }
  } else if (
    $("#currency-type")[0].value == "usd" &&
    !(parseInt(new_product_price_usd) > 0)
  ) {
    managePaymentOptions(local_currency, "once");
    $(".currency_container").hide();
  } else if (
    $("#currency-type")[0].value == local_currency &&
    parseInt(new_product_price) > 0
  ) {
    if (!(parseInt(new_product_price_usd) > 0)) {
      $(".currency_container").hide();
    } else {
      $(".currency_container").show();
    }
  } else if (
    $("#currency-type")[0].value == local_currency &&
    !(parseInt(new_product_price) > 0)
  ) {
    managePaymentOptions("usd", "once");
    $(".currency_container").hide();
  }
};
